import { createContext } from 'react';

type IconsContextProps = {
  arrowUpIconSelect?: string;
  arrowUpAria?: string;
  arrowDownSelect?: string;
  arrowDownAria?: string;
  arrowRightSelect?: string;
  arrowRightAria?: string;
  showAllFilters?: boolean;
};

type TextContext = {
  clearLabel?: string;
  clearAriaLabel?: string;
};

type AppliedStyles = {
  searchbarStyles: string;
};

export const IconsContext = createContext<IconsContextProps>({});
export const TextContext = createContext<TextContext>({});
export const AppliedStylesContext = createContext<AppliedStyles>({ searchbarStyles: '' });
